module.exports = __webpack_public_path__ + "ec4c2345285e9548dbec1c1b3b05a6bd.pdf";